import axios from '../axios'
import qs from 'qs';

/* 
 * 全局模块
*/

// 查询一个表内多个字段的去重复值（用于数据录入）
export const getOptions = (data) => {
    data = qs.stringify(data);
    return axios({
        url: '/config/distinct',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/global.js